import React, { useMemo, useState, useEffect } from "react";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import { isLiveStatus, isFinishedStatus, isStartListStatus } from "helpers/status";
import Label from "components/general/Label"
import Status from "components/presentation/Status";
//General
import ColumnsGeneraltartSM from 'components/sports/ath/general/start/ColumnsSM'
import PhotoFinish from "components/general/PhotoFinish";
//Races
//Block Start
import ColumnsRaceStartBlockStart from 'components/sports/ath/race_track_sb/start/Columns'
import ColumnsRaceStartBlockStartSM from 'components/sports/ath/race_track_sb/start/ColumnsSM'
import ColumnsRaceStartBlockRes from 'components/sports/ath/race_track_sb/result/Columns'
import ColumnsRaceStartBlockResSM from 'components/sports/ath/race_track_sb/result/ColumnsSM'
import ColumnsRaceStartBlockResCombSM from 'components/sports/ath/race_track_sb/result/ColumnsCombSM'
//Without Block start and 800 no Road Races
import ColumnsRaceWSBStart from 'components/sports/ath/race_track_wsb/start/Columns'
import ColumnsRaceWSBResLive from 'components/sports/ath/race_track_wsb/results/ColumnsLive'
import ColumnsRaceWSBResLiveSM from 'components/sports/ath/race_track_wsb/results/ColumnsLiveSM'
import ColumnsRaceWSBRes from 'components/sports/ath/race_track_wsb/results/ColumnsFinish'
import ColumnsRaceWSBResSM from 'components/sports/ath/race_track_wsb/results/ColumnsFinishSM'
import { TableExpanded as TableExpandedRaceWSB } from 'components/sports/ath/race_track_wsb/results/TableExpanded'
//Block Relay 
import ColumnsRaceRelayStart from 'components/sports/ath/relay/start/Columns'
import { TableExpanded as TableExpandedRelayStart } from 'components/sports/ath/relay/start/TableExpanded'
import ColumnsRaceRelayFinish from 'components/sports/ath/relay/result/ColumnsFinish'
import ColumnsRaceRelayLive from 'components/sports/ath/relay/result/ColumnsLive'
import { TableExpanded as TableExpandedRelay } from 'components/sports/ath/relay/result/TableExpanded'
//Road races
import ColumnsRoadSM from 'components/sports/ath/race_road/start/ColumnsRoadSM'
import ColumnsRaceRoadStart from 'components/sports/ath/race_road/start/Columns'
import ColumnsRaceRoadResLive from 'components/sports/ath/race_road/results/ColumnsLive'
import ColumnsRaceRoadResLiveSM from 'components/sports/ath/race_road/results/ColumnsLiveSM'
import ColumnsRaceRoadRes from 'components/sports/ath/race_road/results/ColumnsFinish'
import ColumnsRaceRoadResSM from 'components/sports/ath/race_road/results/ColumnsFinishSM'


import { TableExpanded as TableExpandedRaceRoad } from 'components/sports/ath/race_road/results/TableExpanded'
//Vertical Jumps
import ColumnsVJumpsStart from 'components/sports/ath/vjumps/start/Columns'
import ColumnsVJumpsResLive from 'components/sports/ath/vjumps/results/ColumnsLive'
import ColumnsVJumpsResLiveSM from 'components/sports/ath/vjumps/results/ColumnsLiveSM'
import ColumnsVJumpsRes from 'components/sports/ath/vjumps/results/ColumnsFinish'
import ColumnsVJumpsCombRes from 'components/sports/ath/vjumps/results/ColumnsCombFinish' // Combined
import ColumnsVJumpsResSM from 'components/sports/ath/vjumps/results/ColumnsFinishSM'
import ColumnsVJumpsCombResSM from 'components/sports/ath/vjumps/results/ColumnsCombFinishSM'     // Combined
import { TableExpanded as TableExpandedVJumps } from 'components/sports/ath/vjumps/results/TableExpanded'
//Horizontal Jumps
import ColumnsHJumpsStart from 'components/sports/ath/hjumps/start/Columns'
import ColumnsHJumpsResLive from 'components/sports/ath/hjumps/results/ColumnsLive'
import ColumnsHJumpsResLiveSM from 'components/sports/ath/hjumps/results/ColumnsLiveSM'
import ColumnsHJumpsRes from 'components/sports/ath/hjumps/results/ColumnsFinish'
import ColumnsHJumpsCombRes from 'components/sports/ath/hjumps/results/ColumnsCombFinish' // Combined
import ColumnsHJumpsResSM from 'components/sports/ath/hjumps/results/ColumnsFinishSM'
import ColumnsHJumpsCombResSM from 'components/sports/ath/hjumps/results/ColumnsFinishSM'// Combined
import { TableExpanded as TableExpandedHJumps } from 'components/sports/ath/hjumps/results/TableExpanded'
//Throws
import ColumnsThrowsStar from 'components/sports/ath/throws/start/Columns'
import ColumnsThrowsResLive from 'components/sports/ath/throws/results/ColumnsLive'
import ColumnsThrowsResLiveSM from 'components/sports/ath/throws/results/ColumnsLiveSM'
import ColumnsThrowsRes from 'components/sports/ath/throws/results/ColumnsFinish'
import ColumnsThrowsCombRes from 'components/sports/ath/throws/results/ColumnsCombFinish' // Combined
import ColumnsThrowsResSM from 'components/sports/ath/throws/results/ColumnsFinishSM'
import ColumnsThrowsCombResSM from 'components/sports/ath/throws/results/ColumnsFinishSM' // Combined
import { TableExpanded as TableExpandedThrows } from 'components/sports/ath/throws/results/TableExpanded'
//Decathlon,Heptathon
import { CATEGORY, getIsEvent800m, getIsEventRoad, getIsEventRelay, getIsEventCombined, isPhaseFinal } from 'components/sports/ath/helper/AthHelpers'
import { useViewport } from 'components/general/useViewPort'
import { findArray, isParalympic } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
//Live Now
import LiveNow from 'components/sports/ath/general/LiveNow'
//ProgressBar 
import { ProgressBarTRI as ProgressBar } from 'components/general/ProgressBar';
import LiveCheckBox from "components/general/LiveCheckbox";
import NotAvailable from "components/common/NotAvailable";
//Collapse
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusCircle, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import Collapse from 'react-bootstrap/Collapse';
import { CompetitionFromStore } from "helpers/utils";

const competition = CompetitionFromStore();
const iconClose = competition === 'EG2023' ? faMinusCircle : faCaretDown;
const iconOpen = competition === 'EG2023' ? faPlusCircle : faCaretRight;

const arrowDown = <FontAwesomeIcon icon={iconClose} />
const arrowUp = <FontAwesomeIcon icon={iconOpen} />


function ExpandedComponent({ row, type, isStartList, isStartingLine, isEvent800, isEventRoad, isEventRelay, breakPoint, config }) {
    switch (type) {
        case CATEGORY.RACE: //Track events  with starting blocks
            if (isStartingLine && !isEvent800 && !isEventRelay) {
            } else if (isEventRoad) {
                return <TableExpandedRaceRoad row={row?.original} config={config} />
            } else if (isEventRelay) {

                if (isStartList) {
                    return <TableExpandedRelayStart row={row?.original} />
                } else {
                    return <TableExpandedRelay row={row?.original} />
                }
            } else {
                return <TableExpandedRaceWSB row={row?.original} config={config} />
            }
            break
        case CATEGORY.VJUMPS: //Vertical Jumps
            return <TableExpandedVJumps row={row?.original} config={config} />
        case CATEGORY.HJUMPS: //Vertical Jumps
            return <TableExpandedHJumps row={row?.original} config={config} />
        case CATEGORY.THROWS: //Vertical Jumps
            return <TableExpandedThrows row={row?.original} config={config} />
        default:
            return <div>None</div>
    }
}

const GetConfiguration = (data, rsc, resultStatus, scheduleStatus, breakPoint) => {
    const type = findArray(data?.config?.extendedConfig, { code: ['CATEGORY'] }).value
    // const scheduleStatus = data?.results?.schedule?.status?.code;
    const isStartingLine = findArray(data?.config?.extendedConfig, { code: ['START_IN_LANES'] })?.value === 'Y' ? true : false
    const isEvent800 = getIsEvent800m(rsc);
    const isEventRoad = getIsEventRoad(rsc);
    const isEventCombined = getIsEventCombined(rsc);
    const isEventRelay = getIsEventRelay(rsc);
    const columnsAdded = data?.results?.extendedInfos ? data.results.extendedInfos.sort((a, b) => a.ei_pos - b.ei_pos) : []
    const isStartList = resultStatus === 'START_LIST';
    const isLive = isLiveStatus(resultStatus);

    let configuration = {
        columns: [],
        subComponent: null,
        caption: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            category: type,
            isStartList: isStartList,
            isStartingLine: isStartingLine,
            isEvent800: isEvent800,
            isEventRoad: isEventRoad,
            isEventRelay: isEventRelay,
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }

    };

    configuration.sortBy = isStartList
        ? [{ id: 'StartOrder', desc: false }]
        : [{ id: 'Rank', desc: false }]

    if (isEventRoad) {
        configuration.sortBy = isStartList
            ? [{ id: 'StartOrder', desc: false }]
            : isLive ? [{ id: 'RankIntermediate', desc: false }] : [{ id: 'Rank', desc: false }]
    }


    switch (type) {
        case CATEGORY.RACE: //Races
            configuration.filters = {
                ei_type: ['DISPLAY'],
                ei_code: ['INTERMEDIATE_CURRENT']
            };

            if (isStartingLine && !isEvent800 && !isEventRelay) { //Track events with starting blocks
                configuration.columns = isStartList
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsRaceStartBlockStartSM()
                        : ColumnsRaceStartBlockStart()
                    : breakPoint === "sm" || breakPoint === "xs"
                        ? isEventCombined ? ColumnsRaceStartBlockResCombSM()
                            : ColumnsRaceStartBlockResSM()
                        : ColumnsRaceStartBlockRes()
            } else if (isEventRoad) { //Road
                configuration.columns = isStartList
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsRoadSM()
                        : ColumnsRaceRoadStart()
                    : isLive
                        ? breakPoint === "sm" || breakPoint === "xs"
                            ? ColumnsRaceRoadResLiveSM(columnsAdded)
                            : ColumnsRaceRoadResLive(columnsAdded)
                        : breakPoint === "sm" || breakPoint === "xs"
                            ? ColumnsRaceRoadResSM(columnsAdded)
                            : ColumnsRaceRoadRes(columnsAdded);
            } else if (isEventRelay) { //Relay
                configuration.sortBy = isStartList
                    ? [{ id: 'StartOrder', desc: false }]
                    : isLive
                        ? [{ id: 'RankIntermediate', desc: false }]
                        : [{ id: 'Rank', desc: false }]

                configuration.columns = isStartList
                    ? ColumnsRaceRelayStart()
                    : isLive
                        ? ColumnsRaceRelayLive(columnsAdded)
                        : ColumnsRaceRelayFinish(columnsAdded);

            } else { //Track events without starting blocks

                configuration.sortBy = isStartList
                    ? [{ id: 'StartOrder', desc: false }]
                    : isLive
                        ? [{ id: 'RankIntermediate', desc: false }]
                        : [{ id: 'Rank', desc: false }]

                configuration.columns = isStartList
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsGeneraltartSM()
                        : ColumnsRaceWSBStart()
                    : isLive
                        ? breakPoint === "sm" || breakPoint === "xs"
                            ? ColumnsRaceWSBResLiveSM(columnsAdded)
                            : ColumnsRaceWSBResLive(columnsAdded)
                        : breakPoint === "sm" || breakPoint === "xs"
                            ? ColumnsRaceWSBResSM(columnsAdded)
                            : ColumnsRaceWSBRes(columnsAdded);
            }
            break;
        case CATEGORY.VJUMPS: //Vertical Jumps
            configuration.configs.previousCurrent = true;
            configuration.filters = {
                ei_type: ['DISPLAY'],
                ei_code: ['INTERMEDIATE_ATTEMPT_CURRENT']
            };
            configuration.columns = isStartList
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsGeneraltartSM()
                    : ColumnsVJumpsStart()
                : isLive
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsVJumpsResLiveSM(columnsAdded)
                        : ColumnsVJumpsResLive(columnsAdded)
                    : breakPoint === "sm" || breakPoint === "xs"
                        ? isEventCombined ? ColumnsVJumpsCombResSM(columnsAdded)
                            : ColumnsVJumpsResSM(columnsAdded)
                        : isEventCombined ? ColumnsVJumpsCombRes(columnsAdded)
                            : ColumnsVJumpsRes(columnsAdded);

            break;

        case CATEGORY.HJUMPS: //Horizontal Jumps
            configuration.sortBy = isStartList || isLive
                ? [{ id: 'StartOrder', desc: false }]
                : [{ id: 'Rank', desc: false }]

            configuration.configs.previousCurrent = true;
            configuration.filters = {
                ei_type: ['DISPLAY'],
                ei_code: ['INTERMEDIATE_ATTEMPT_CURRENT']
            };
            configuration.columns = isStartList
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsGeneraltartSM()
                    : ColumnsHJumpsStart()
                : isLive
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsHJumpsResLiveSM(columnsAdded)
                        : ColumnsHJumpsResLive(columnsAdded)
                    : breakPoint === "sm" || breakPoint === "xs"
                        ? isEventCombined ? ColumnsHJumpsCombResSM(columnsAdded)
                            : ColumnsHJumpsResSM(columnsAdded)
                        : isEventCombined ? ColumnsHJumpsCombRes(columnsAdded)
                            : ColumnsHJumpsRes(columnsAdded);

            break;

        case CATEGORY.THROWS:
            configuration.configs.previousCurrent = true;
            configuration.columns = isStartList
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsGeneraltartSM()
                    : ColumnsThrowsStar()
                : isLive
                    ? breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnsThrowsResLiveSM(columnsAdded, isPhaseFinal(rsc))
                        : ColumnsThrowsResLive(columnsAdded)
                    : breakPoint === "sm" || breakPoint === "xs"
                        ? isEventCombined ? ColumnsThrowsCombResSM(columnsAdded)
                            : ColumnsThrowsResSM(columnsAdded)
                        : isEventCombined ? ColumnsThrowsCombRes(columnsAdded)
                            : ColumnsThrowsRes(columnsAdded);
            break;

        default:
            configuration.columns = []
    }

    return configuration;
};


const AthResults = ({ data, numHeats }) => {
    const { mirs_rsc, mirs_competition } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")

    //Used for collapse, 
    const [open, setOpen] = useState(false);
    const [arrow, setArrow] = useState(arrowUp);
    const [openAll, setOpenAll] = useState(true);
    useEffect(() => {
        if (openAll) {
            setArrow(arrowDown)
        } else {
            setArrow(arrowUp)
        }
        setOpen(openAll);
    }, [openAll])

    const handleClick = () => {
        if (open) {
            setArrow(arrowUp)
        } else {
            setArrow(arrowDown)
        }
        setOpen(!open);
    }

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => GetConfiguration(data, mirs_rsc, resultStatus, scheduleStatus, breakPoint), [scheduleStatus, resultStatus, breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <ExpandedComponent
                row={row}
                type={configEvent.configs.category}
                isStartList={configEvent.configs.isStartList}
                isStartingLine={configEvent.configs.isStartingLine}
                isEvent800={configEvent.configs.isEvent800}
                isEventRoad={configEvent.configs.isEventRoad}
                isEventRelay={configEvent.configs.isEventRelay}
                breakPoint={breakPoint}
                config={configEvent.configs.columnsAdded} />
        }
        />
        // eslint-disable-next-line
    ), [resultStatus]);


    const items = data?.results?.items
    const type = findArray(data?.config?.extendedConfig, { code: ['CATEGORY'] }).value
    const isStartingLine = findArray(data?.config?.extendedConfig, { code: ['START_IN_LANES'] })?.value === 'Y' ? true : false
    const isEvent800 = getIsEvent800m(mirs_rsc);
    const isEventRelay = getIsEventRelay(mirs_rsc);
    const isEventRoad = getIsEventRoad(mirs_rsc);

    const showAllExtendedResults = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    const showAllresultAnalysis = items?.some(item => item?.resultAnalysis?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    const showAllEsl = items?.some(item => item?.extCompetitor);

    //chequear en relevos?
    const showAllTeamAthletes = items?.some(item => item.teamAthletes && Array.isArray(item.teamAthletes) && item.teamAthletes.length > 0);

    const showAll = showAllExtendedResults || showAllresultAnalysis || showAllEsl || isEventRelay;


    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!showAll) hiddenColumns.push('Expander')

    const showWarnings = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'YC' || item.er_code === 'RC' || item.er_code === 'YRC' || item.er_code === 'FALSE_START' || item.er_code === 'LANE_INFRINGE'));
    if (!showWarnings) hiddenColumns.push('Warnings')

    const showTileRule = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'RULE' || item.er_code === 'MS'));
    if (!showTileRule) hiddenColumns.push('TieRules')

    const showRecords = items?.some(item => item?.recordIndicators?.some(item => item.ri_order === 1));
    if (!showRecords) hiddenColumns.push('Records')

    const showQualMark = items?.some(item => item?.qualificationMark);
    if (!showQualMark) hiddenColumns.push('QualMark')

    const showPoints = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'PTS'));
    if (!showPoints && getIsEventCombined) hiddenColumns.push('Points')

    //Hidden in responsive but used for sorting in road events
    if (isEventRoad && breakPoint === 'sm' || breakPoint === 'xs') hiddenColumns.push('StartOrder')

    if (isParalympic(mirs_competition)) { hiddenColumns.push('RANK_WLD') }

    const filtersFinalSplit = {
        ei_type: ['UI'],
        ei_code: ['INTERMEDIATES_TOTAL']
    };

    const filtersCurrentCompetitor = {
        ei_type: ['DISPLAY'],
        ei_code: ['CURRENT']
    };

    let extendedInfos = data?.results?.extendedInfos
    let finalSplit = extendedInfos && findArray(extendedInfos, filtersFinalSplit).ei_value;
    let currentSplit = extendedInfos && findArray(extendedInfos, configEvent.filters).ei_value;
    let currentCompetitor = extendedInfos && findArray(extendedInfos, filtersCurrentCompetitor).ei_value


    currentSplit = (currentSplit === 'F') ? finalSplit : currentSplit // ponemos un numero muy alto prar que internamente se posicione en el ultimo 
    currentSplit = (currentSplit === undefined) ? 1 : currentSplit
    //numero de splits visibles 

    let showNavExtendedData = false

    let extendedColsVisibles = 3
    let isWBS = false
    let isBS = false
    //Races
    if (type === CATEGORY.RACE) {
        //Races
        if (isStartingLine && !isEvent800 && !isEventRelay) { //Track events with starting blocks
            isBS = true;
        } else if (isEventRoad) { //Road
        } else if (isEventRelay) { //Relay
            extendedColsVisibles = 4
        } else { //Track events without starting blocks
            isWBS = true;
            //extendedColsVisibles = 3
        }
    }
    if (type === CATEGORY.VJUMPS) {
        extendedColsVisibles = 5
        let numIntermediates = findArray(data?.results?.extendedInfos, { ei_code: ['INTERMEDIATES_TOTAL'] })?.ei_value
        showNavExtendedData = Number(numIntermediates) > 5 ? true : false
    }

    const getProgessBarConfiguration = () => {
        let config = {
            distance: {
                unit: 'm',
            },
        }
        isFinishedStatus(resultStatus)
            ? config.numColVisibles = { sm: 1, lg: 2 }
            : config.numColVisibles = { sm: 1, lg: 4 }
        if (type === CATEGORY.RACE) {
            if (isStartingLine && !isEvent800 && !isEventRelay) { //Track events with starting blocks
            } else if (isEventRoad) { //Road
            } else if (isEventRelay) { //Relay
                config.breakpoints = {
                    0: { slidesPerView: 4 }
                }
                isFinishedStatus(resultStatus)
                    ? config.numColVisibles = { sm: 1, lg: 2 }
                    : config.numColVisibles = { sm: 1, lg: 4 }

            } else { //Track events without starting blocks
                let _breakpoints = config.breakpoints || {
                    0: { slidesPerView: 3 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 6 },
                }
                isFinishedStatus(resultStatus)
                    ? config.numColVisibles = { sm: 1, lg: 2 }
                    : config.numColVisibles = { sm: 1, lg: 3 }
            }
        }
        return config;
    }

    const progressBarConfig = getProgessBarConfiguration();
    const _isLiveStatus = isLiveStatus(resultStatus);
    //const _isStartListStatus = isStartListStatus(resultStatus);
    //let itemsSorts = items;
    /*
        if (_isStartListStatus) {
            itemsSorts = items ? items.sort((a, b) => b.startSortOrder - a.startSortOrder) : []
        } else {
            itemsSorts = items ? items.sort((a, b) => b.sortOrder - a.sortOrder) : []
        }
    */

    let relatedTimeline = false
    if (_isLiveStatus && !isEvent800 && (isWBS || (isEventRelay && isMobile))) {
        relatedTimeline = true;
    }
    let unitRSC = data?.results?.eventUnitCode;


    //windspeed used on caption
    let windSpeed = data?.results?.extendedInfos?.find(row => row.ei_code === 'WIND_SPEED');
    let wind = windSpeed?.ei_value;

    wind = wind !== undefined ? <><strong><Label data='HeaderWind' />: {wind} <Label data='HeaderMperS' /></strong></>
        : ''
    //Caption for table, numHeats > 1 checks if it is loaded with or without the arrow to collapse/expand
    const caption = <CaptionTable
        leftCol={data && data.results.eventUnit.shortDescription}
        centerCol={wind}
        rightCol={
            numHeats > 1 ?
                <>
                    <div className="d-flex bg-secondary">
                        <Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
                        <div className="arrow ms-3" onClick={(e) => handleClick()}>{arrow}</div>
                    </div>
                </>
                : <Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
        }

    />

    return (
        <>
            {data?.results ? (
                <>
                    {/* LIVE NOW */}
                    {(!isParalympic(mirs_competition) && _isLiveStatus && !isEventRoad) &&
                        <LiveNow data={data} configEvent={configEvent} />
                    }

                    {/* ProgressBar show in wbs mobile only */}
                    {
                        _isLiveStatus && !isEvent800 && (isWBS || (isEventRelay && isMobile))
                        && <>

                            <LiveCheckBox id={`mirs-livecheckbox-${unitRSC}`} />
                            <ProgressBar id={`mirs-progressbar-${unitRSC}`} data={data?.progressBar} config={progressBarConfig} dinamic={true} />
                        </>
                    }

                    {/* Photofinish */}
                    {!isParalympic(mirs_competition) && data?.images && <div className=' d-flex flex-row justify-content-end mb-2'><strong><Label data='LabelPhotoFinish' />:&nbsp;</strong><PhotoFinish data={data?.images} /></div>}

                    {items ? (
                        <>
                            {numHeats > 1 && <div className="bg-secondary">
                                {caption}
                            </div>}
                            <Collapse in={open} className="mb-3">
                                < MirsTable
                                    sortable={!isMobile}
                                    //Dato to show by row
                                    data={items}
                                    //Columnas a visualizar 
                                    columns={configEvent.columns}
                                    //subcomponente a renderizar, extended
                                    renderRowSubComponent={renderRowSubComponent}
                                    //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
                                    //Key by row necesary in order to no paint innecesary
                                    keyRow='participant-code'
                                    //Splits to show
                                    colsExtendedVisible={extendedColsVisibles}
                                    //current split (initial)
                                    colIndex={parseInt(currentSplit) <= extendedColsVisibles ? extendedColsVisibles : parseInt(currentSplit)} //Columna Posicionada con splits
                                    //Component caption
                                    caption={numHeats > 1 ? '' : caption}
                                    //Columns to hidde 
                                    hiddenColumns={hiddenColumns}
                                    //When show tble is sorted by 
                                    initialSortBy={configEvent.sortBy}
                                    //Show buttons move to splits 
                                    showNavExtendedData={showNavExtendedData}
                                    //Indicate if has related timeline
                                    hasRelatedTimeline={relatedTimeline}

                                    //add current class to current competitor
                                    getRowProps={row => ({
                                        className: currentCompetitor && row.original?.participant?.code === currentCompetitor ? 'currentIndicator' : '',
                                    })}
                                    classCaption={isLiveStatus(resultStatus) ? 'currentIndicator' : ''}

                                /*
                                    getHeaderProps={column => ({})}
                                    getColumnProps={column => ({onClick: () => alert('Column!'),})}
                                    getCellProps={cellInfo => ({
                                        style: {
                                            // backgroundColor: 'red',
                                        },
                                    })}
                                
                                */
                                />
                            </Collapse>
                        </>
                    ) : ('')
                    }

                </>
            ) : (
                <NotAvailable />
            )
            }
        </>
    );
};

export default AthResults;
